import { noTokenAxios as axios } from '@/api'

export interface CampaignProps {
  id: number;
  key: string;
  assign_group: string;
}

export interface ResponseAbTest {
  id: number;
  campaigns: CampaignProps[];
}

export const getAbTest = () => {
  return axios.get('/api/guest/').then((response): ResponseAbTest => response.data)
}
